import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RelatorioService {

  constructor(private http: HttpClient) { }

  gerarPdfPapeleta(
    matricula: number,
    apenasData: string,
    concordo: boolean,
    folhaServicoId: number
  ): Observable<Blob> {

    const params = new HttpParams()
      .set('matricula', matricula.toString())
      .set('data', apenasData)
      .set('concordo', concordo.toString())
      .set('folhaServicoId', folhaServicoId.toString());

    return this.http.get(
      `/relatorio/PDF`,
      {
        params,
        responseType: 'blob',
        observe: 'response'
      }
    ).pipe(
      switchMap((response: HttpResponse<Blob>) => {
        return of(response.body as Blob);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof Blob) {
          return new Observable<Blob>(observer => {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorMessage = JSON.parse(reader.result as string);
                observer.error(errorMessage);
              } catch (e) {
                observer.error({ erro: reader.result });
              }
            };
            reader.onerror = () => {
              observer.error({ erro: 'Erro ao ler resposta do servidor' });
            };
            reader.readAsText(error.error);
          });
        }
        return throwError(() => error);
      })
    );
  }

  visualizarPDF(
    matricula: number,
    data: string,
    folhaServicoId: number
  ): Observable<Blob> {

    return this.http.get(
      `/relatorio/PDF/assinado/${matricula}/${data}/${folhaServicoId}`,
      {
        responseType: 'blob',
        observe: 'response'
      }
    ).pipe(
      switchMap((response: HttpResponse<Blob>) => {
        return of(response.body as Blob);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof Blob) {
          return new Observable<Blob>(observer => {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorMessage = JSON.parse(reader.result as string);
                observer.error(errorMessage);
              } catch (e) {
                observer.error({ erro: reader.result });
              }
            };
            reader.onerror = () => {
              observer.error({ erro: 'Erro ao ler resposta do servidor' });
            };
            reader.readAsText(error.error);
          });
        }
        return throwError(() => error);
      })
    );
  }

  visualizarPDFSemAssinatura(
    matricula: number,
    data: string,
    folhaServicoId: number
  ): Observable<Blob> {
    const params = new HttpParams()
      .set('matricula', matricula.toString())
      .set('data', data)
      .set('concordo', 'false')
      .set('folhaServicoId', folhaServicoId.toString());

    return this.http.get(
      `/relatorio/PDF`,
      {
        params,
        responseType: 'blob',
        observe: 'response'
      }
    ).pipe(
      switchMap((response: HttpResponse<Blob>) => {
        return of(response.body as Blob);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof Blob) {
          return new Observable<Blob>(observer => {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorMessage = JSON.parse(reader.result as string);
                observer.error(errorMessage);
              } catch (e) {
                observer.error({ erro: reader.result });
              }
            };
            reader.onerror = () => {
              observer.error({ erro: 'Erro ao ler resposta do servidor' });
            };
            reader.readAsText(error.error);
          });
        }
        return throwError(() => error);
      })
    );
  }

  gerarPdfAgrupado(
    matricula: number,
    dataInicial: string,
    dataFinal: string
  ): Observable<Blob> {
    return this.http.get(
      `/relatorio/PDF/agrupado/${matricula}/${dataInicial}/${dataFinal}`,
      {
        responseType: 'blob',
        observe: 'response'
      }
    ).pipe(
      switchMap((response: HttpResponse<Blob>) => {
        return of(response.body as Blob);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof Blob) {
          return new Observable<Blob>(observer => {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorMessage = JSON.parse(reader.result as string);
                observer.error(errorMessage);
              } catch (e) {
                observer.error({ erro: reader.result });
              }
            };
            reader.onerror = () => {
              observer.error({ erro: 'Erro ao ler resposta do servidor' });
            };
            reader.readAsText(error.error);
          });
        }
        return throwError(() => error);
      })
    );
  }

  obterExtratoPapeleta(
    matricula: number,
    dataInicial: string,
    dataFinal: string
  ): Observable<Blob> {
    const params = new HttpParams()
      .set('dataInicial', dataInicial)
      .set('dataFinal', dataFinal);

    return this.http.get(
      `/integracao-papeleta/PDF/extrato-papeleta/${matricula}`,
      {
        params,
        responseType: 'blob',
        observe: 'response'
      }
    ).pipe(
      switchMap((response: HttpResponse<Blob>) => {
        return of(response.body as Blob);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof Blob) {
          return new Observable<Blob>(observer => {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorMessage = JSON.parse(reader.result as string);
                observer.error(errorMessage);
              } catch (e) {
                observer.error({ erro: reader.result });
              }
            };
            reader.onerror = () => {
              observer.error({ erro: 'Erro ao ler resposta do servidor' });
            };
            reader.readAsText(error.error);
          });
        }
        return throwError(() => error);
      })
    );
  }
}